var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustrySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "-10 -10 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.56 6.398-5.435 3.458V7.189a.938.938 0 0 0-1.44-.791L6.25 9.856V2.187a.937.937 0 0 0-.938-.937H.938A.937.937 0 0 0 0 2.187v15.625c0 .518.42.938.938.938h18.125c.517 0 .937-.42.937-.938V7.19a.938.938 0 0 0-1.44-.791z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrySmall);
export default __webpack_public_path__ + "static/media/industry-small.336bada39a4da07d779ea59e08657250.svg";
export { ForwardRef as ReactComponent };